import React, { FC } from "react";
import { useStyles } from "./BackButtonStyles";

import { BackButtonProps } from "./types";

export const BackButton: FC<BackButtonProps> = ({ onBack }) => {
  const styles = useStyles();
  const handleClick = () => {
    onBack();
  };
  return (
    <button className={styles.backButtonWrapper} onClick={handleClick}>
      <div className={styles.bar} />
      <div className={styles.barReverse} />
    </button>
  );
};
